import { useEffect } from "react";
import ThemeToggle from "./ThemeToggle";
import "./SideNav.css";

/**
 * Menú lateral de la app (Dashboard y panel del entrenador).
 * Fijo a la izquierda en escritorio; en móvil es un cajón que se abre con el
 * botón de menú de la cabecera (abierto/onCerrar).
 *
 * items: [{ key, label, Icono }]   etiqueta: texto junto a la marca
 * pie: lo que va abajo junto al interruptor de tema (p. ej. el usuario)
 */
export default function SideNav({ items, selected, onSelect, abierto, onCerrar, etiqueta, pie }) {
  // Escape cierra el cajón
  useEffect(() => {
    if (!abierto) return;
    const onKey = (e) => {
      if (e.key === "Escape") onCerrar();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [abierto, onCerrar]);

  return (
    <>
      <div
        className={"sidenav-velo" + (abierto ? " is-open" : "")}
        onClick={onCerrar}
        aria-hidden="true"
      />
      <aside className={"sidenav" + (abierto ? " is-open" : "")} aria-label="Menú principal">
        <div className="sidenav-marca">
          <span className="brand">
            <span className="brand-mark">
              <img src="/titan-mark.png" alt="" />
            </span>
            <span className="brand-name">Titan Training</span>
          </span>
          {etiqueta && <span className="sidenav-etiqueta">{etiqueta}</span>}
        </div>

        <nav className="sidenav-lista">
          {items.map(({ key, label, Icono }) => (
            <button
              key={key}
              type="button"
              className={"sidenav-item" + (selected === key ? " is-active" : "")}
              aria-current={selected === key ? "page" : undefined}
              onClick={() => {
                onSelect(key);
                onCerrar();
              }}
            >
              <Icono aria-hidden="true" />
              <span>{label}</span>
            </button>
          ))}
        </nav>

        <div className="sidenav-pie">
          {pie}
          <ThemeToggle />
        </div>
      </aside>
    </>
  );
}
